namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerEditor()
    export class CsParaEditor extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, CsParaRow> {

        constructor(hidden: JQuery, options: Serenity.LookupEditorOptions) {
            super(hidden, options);
        }

        protected getLookupKey() {
            return 'Administration.CsPara';
        }

        protected getItemText(item, lookup) {
            return super.getItemText(item, lookup);
        }
    }
}